
import { privacyModeTextFormatterMixin } from '@/mixins';
import FormatterService from "@/service/FormatterService";

export default {
    name: 'RealizedKpiCard',

    mixins: [privacyModeTextFormatterMixin],

    props: {
        loading: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            format: new FormatterService()
        }
    },

    computed: {
        secondaryTotals() {
            return this.$store.state.preferences.kpiTotalData?.secondaryTotals || {};
        },
    },

    methods: {
        openReturnValuePopup() {
            this.$root.$emit('request-open-kpi-return-value-popup')
        },
        openKpiHolisticPerformancePopup() {
            this.$root.$emit('request-open-kpi-holistic-performance-index-popup')
        },
        handleOpenPopup() {
            if (this.isHolisticMode) {
                this.openKpiHolisticPerformancePopup();
            } else {
                this.openReturnValuePopup();
            }
        }
    }
}
